import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { UserFraudStatusRBAC } from '../pages/UserFraudStatus/rbac'
import { WatchtowerAreaDetectionRBAC } from '../pages/WatchtowerAreaDetection/rbac'
import { FraudDetectionRBAC } from '../pages/FraudDetection/rbac'
import {
  WatchtowerRuleListRBAC,
  WatchtowerAutoCancelRuleListRBAC,
} from '../pages/WatchTowerRule/rbac'
import { FraudBlacklistAndWhitelistRBAC } from '../pages/BlacklistAndWhitelist/rbac'
import { WatchTowerQueryRuleRBAC } from '../pages/WatchTowerQueryRule/rbac'
import { ReferralFraudRBAC } from '../pages/ReferralFraud/rbac'

const UserFraudStatus = lazy(() => import('../pages/UserFraudStatus'))
const WatchtowerAreaDetection = lazy(() => import('../pages/WatchtowerAreaDetection'))
const FraudDetection = lazy(() => import('../pages/FraudDetection'))
const WatchTowerRule = lazy(() => import('../pages/WatchTowerRule'))
const BlacklistAndWhitelist = lazy(() => import('../pages/BlacklistAndWhitelist'))
const WatchTowerQueryRule = lazy(() => import('pages/Fraud/WatchTowerQueryRule'))
const ReferralFraudPage = lazy(() => import('pages/Fraud/Referral'))

export const UserFraudStatusRouter: RouterFeatureInterface<
  'UserFraudStatusRouter',
  '/dashboard/user-fraud-status'
> = {
  name: 'UserFraudStatusRouter',
  Component: UserFraudStatus,
  path: '/dashboard/user-fraud-status',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: UserFraudStatusRBAC.pageID,
}

export const WatchtowerAreaDetectionRouter: RouterFeatureInterface<
  'WatchtowerAreaDetectionRouter',
  '/dashboard/fraud/watchtower/area-detection'
> = {
  name: 'WatchtowerAreaDetectionRouter',
  Component: WatchtowerAreaDetection,
  path: '/dashboard/fraud/watchtower/area-detection',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: WatchtowerAreaDetectionRBAC.pageID,
}

const FraudDetectionRouter: RouterFeatureInterface<
  'FraudDetectionRouter',
  '/dashboard/fraud-detection'
> = {
  name: 'FraudDetectionRouter',
  Component: FraudDetection,
  path: '/dashboard/fraud-detection',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: FraudDetectionRBAC.pageID,
  isDashboard: true,
}

export const WatchTowerRuleRouter: RouterFeatureInterface<
  'WatchTowerRuleRouter',
  '/dashboard/fraud/watchtower/rule'
> = {
  name: 'WatchTowerRuleRouter',
  Component: WatchTowerRule,
  path: '/dashboard/fraud/watchtower/rule',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: WatchtowerRuleListRBAC.pageID,
  isDashboard: true,
}

export const WatchTowerAutoCancelRuleListRouter: RouterFeatureInterface<
  'WatchTowerAutoCancelRuleListRouter',
  '/dashboard/fraud/watchtower/auto-cancel-rule-list'
> = {
  name: 'WatchTowerAutoCancelRuleListRouter',
  Component: WatchTowerRule,
  path: '/dashboard/fraud/watchtower/auto-cancel-rule-list',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: WatchtowerAutoCancelRuleListRBAC.pageID,
  isDashboard: true,
}

export const BlacklistAndWhitelistRouter: RouterFeatureInterface<
  'BlacklistAndWhitelist',
  '/dashboard/fraud/black-and-white-list'
> = {
  name: 'BlacklistAndWhitelist',
  Component: BlacklistAndWhitelist,
  path: '/dashboard/fraud/black-and-white-list',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: FraudBlacklistAndWhitelistRBAC.pageID,
  isDashboard: true,
}

export const WatchTowerQueryRuleRouter: RouterFeatureInterface<
  'WatchTowerQueryRuleRouter',
  '/dashboard/fraud/watchtower/query-rule'
> = {
  name: 'WatchTowerQueryRuleRouter',
  Component: WatchTowerQueryRule,
  path: '/dashboard/fraud/watchtower/query-rule',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: WatchTowerQueryRuleRBAC.pageID,
  isDashboard: true,
}

export const ReferralFraudRouter: RouterFeatureInterface<
  'ReferralFraudRouter',
  '/dashboard/fraud/referral'
> = {
  name: 'ReferralFraudRouter',
  Component: ReferralFraudPage,
  path: '/dashboard/fraud/referral',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: ReferralFraudRBAC.pageID,
  isDashboard: true,
}

const FraudRouter = [
  UserFraudStatusRouter,
  FraudDetectionRouter,
  WatchtowerAreaDetectionRouter,
  WatchTowerRuleRouter,
  WatchTowerAutoCancelRuleListRouter,
  BlacklistAndWhitelistRouter,
  WatchTowerQueryRuleRouter,
  ReferralFraudRouter,
]

export const FraudRouterDetail = generateRouterDetail(FraudRouter)

export default FraudRouter
